var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ob1-popin-modal2",
    {
      attrs: {
        id: _vm.id,
        "aria-labelledby": _vm.id + "_title",
        "show-close-button": false,
      },
    },
    [
      _c("div", { staticClass: "h4", attrs: { id: _vm.id + "_title" } }, [
        _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "m-0" }, [
        _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-6 mb-1 d-md-flex" },
          [
            _c(
              "ob1-cards",
              {
                staticClass: "d-flex p-1 align-items-center",
                attrs: { "is-link": true, link: _vm.clientHref },
              },
              [
                _c("div", { staticClass: "m-1" }, [
                  _c("span", { staticClass: "icon-avatar font-size-30" }),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "lead p-0" }, [
                    _c("strong", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.clientTitle) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small p-0" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.clientDescription) +
                        "\n                    "
                    ),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-12 col-md-6 mb-1 d-md-flex" },
          [
            _c(
              "ob1-cards",
              {
                staticClass: "d-flex p-1 align-items-center",
                attrs: { "is-link": true, link: _vm.newClientHref },
              },
              [
                _c("div", { staticClass: "m-1" }, [
                  _c("span", { staticClass: "icon-Add-person font-size-30" }),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticClass: "lead p-0" }, [
                    _c("strong", [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.newClientTitle) +
                          "\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "small p-0" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.newClientDescription) +
                        "\n                    "
                    ),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }